import React from "react";
import { MapPin, Video } from "lucide-react";
import LpCta from "./LpCta";
import { ADDRESS } from "./lpData";

const LpLocalizacao = () => (
  <section className="section-pad bg-white" data-testid="lp-localizacao">
    <div className="aevos-container grid lg:grid-cols-12 gap-12 items-center">
      <div className="lg:col-span-5">
        <h2 className="font-display font-bold text-3xl md:text-5xl leading-[1.08]">
          Emagrecimento e avaliação metabólica em Mogi das Cruzes
        </h2>
        <p className="mt-5 text-[#333333] text-base md:text-lg leading-relaxed">
          Atendimento médico presencial na AEVOS, com recursos para avaliação do gasto energético e
          da composição corporal, conforme indicação.
        </p>

        <address className="not-italic mt-8 space-y-3 text-[#333333] text-sm md:text-base" data-testid="lp-address">
          <p className="flex items-start gap-3">
            <MapPin size={18} className="text-[#00C4FF] mt-0.5 flex-shrink-0" />
            <span>
              {ADDRESS.street}
              <br />
              {ADDRESS.city}
              <br />
              {ADDRESS.cep}
            </span>
          </p>
          <p className="flex items-center gap-3">
            <Video size={18} className="text-[#00C4FF] flex-shrink-0" />
            Consultas presenciais e online.
          </p>
        </address>

        <div className="mt-10">
          <LpCta
            location="localizacao"
           
            message="Olá! Vim pela página de emagrecimento da AEVOS e gostaria de consultar a disponibilidade de horários."
          >
            Consultar disponibilidade de horários
          </LpCta>
        </div>
      </div>

      <div className="lg:col-span-7">
        <iframe
          title="Mapa — AEVOS Mogi das Cruzes"
          src={ADDRESS.mapsEmbed}
          className="w-full h-[320px] md:h-[440px] border border-[#E0E0E0]"
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
          allowFullScreen
          data-testid="lp-map"
        />
      </div>
    </div>
  </section>
);

export default LpLocalizacao;
